<div class="outer-container">
    <app-current-path *ngIf="showPath"></app-current-path>
    <div class="console-container">

        <div class="row menu">
            <div class="col-6">
                <div class="fs-12" style="cursor: pointer; color: #007bff;" (click)="closeTaskSelectionMenu()">← Back</div>
                <span class="menu-heading"> Interaction Details </span>
                <div class="fs-12" style="margin-top: 0.4rem;" *ngIf="interactionDetailedData?.InteractionID ||  interactionId">
                    Interaction {{ interactionDetailedData?.InteractionID || interactionId }} -
                    {{ interactionDetailedData?.Agent }}
                    <span *ngIf="showSurveyDetails">
                        | {{ newName }} {{ selectedType?.Name }} Survey {{ selectedSurvey?.SurveyID }} - Reviewer:
                        {{ userDetails?.FirstName + ' ' + userDetails?.LastName }}
                    </span>
                </div>
            </div>

            <div class="col-4 text-end fs-14" style="width: 37%;padding-top: 24px;">
                Status: <span *ngIf="this.interactionDetailedData?.AIReview" class="sentiment-positive">
                    {{this.interactionDetailedData?.AIReview}}
                </span>
            </div>

            <div class="col-2 text-end fs-14" style="width: 13%;padding-top: 24px;">
                Score: <span class="score-positive" style="padding-left: 14px;">
                    {{this.interactionDetailedData?.AIScore}}%
                </span>
            </div>

        </div>
        <div class="row mb-3">
                <div [ngClass]="hasAIData ? 'col-8 pr-0' : 'col-12 pr-0'">
                <div class="row m-0 id-container">
                    <div class="verticalScroll verticalBorder" [ngStyle]="{ width: isAudit ? (hasAIData ? '40.5%' : '48%') : '100%' }">
                        <div class="accordion accordion-flush">
                            <div class="accordion-item" id="accordionOne" *ngIf="showAudioTab">
                                <h2 class="accordion-header accordion-button section-heading" data-bs-toggle="collapse"
                                    data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                    RECORDING
                                </h2>
                                <hr class="solid-headerDivider" />

                                <div id="collapseOne" class="accordion-collapse collapse show accordian-padb"
                                    data-bs-parent="#accordionOne">
                                    <div class="accordion-body">
                                        <div class="align-center" *ngIf="showHeader">
                                            <div class="headerdiv">
                                                <div class="tab-heading" *ngFor="let tab of recordingTab; let i = index"
                                                    [ngClass]="tab.isSelected ? 'tab-heading-focus' : ''"
                                                    (click)="TabSelectionChange(tab.index)">
                                                    {{ tab.label }}
                                                </div>
                                            </div>
                                        </div>
                                        <div *ngIf="selectedTab == 'Audio'">
                                            <div class="recHeading" *ngIf="!showHeader">Audio</div>
                                            <hr class="mb-1 solid-headerDivider" *ngIf="!showHeader" />
                                            <div *ngIf="showRecOptions == true && recordingsArray.length > 0"
                                                class="recFont">
                                                <label for="" class="field-label"> Recording</label>

                                                <select [(ngModel)]="selectedRecordingValue"
                                                    (change)="changeRecording($event)" class="field-label recording-select">
                                                    <option *ngFor="let item of recordingsArray; let i = index"
                                                        [ngValue]="item" [selected]="item">
                                                        {{ i + 1 }}
                                                    </option>
                                                </select>
                                                of {{ recordingsArray.length }}
                                            </div>
                                            <!-- <div class="record" *ngIf="isRecordLoaded"> -->
                                            <div class="record"
                                                *ngIf="isRecordLoaded">
                                                <app-videojs-wavesurfer
                                                    [recordingDetails]="recordingDetails"></app-videojs-wavesurfer>
                                            </div>
                                        </div>
                                        <div *ngIf="selectedTab == 'AgentDesktop'">
                                            <div class="recHeading" *ngIf="!showHeader">Agent Desktop</div>
                                            <hr class="mb-1 solid-headerDivider" *ngIf="!showHeader" />
                                            <div *ngIf="showVideoRecOptions == true && videoRecordingsArray.length > 1"
                                                class="recFont">
                                                <label for="" class="field-label"> Recording</label>

                                                <select [(ngModel)]="selectedVideoRec"
                                                    (change)="changeVideoRecording($event)" class="field-label">
                                                    <option *ngFor="let item of videoRecordingsArray; let i = index"
                                                        [ngValue]="item" [selected]="item">
                                                        {{ i + 1 }}
                                                    </option>
                                                </select>
                                                of {{ videoRecordingsArray.length }}
                                            </div>
                                            <!-- <div class="record" *ngIf="isRecordLoaded"> -->
                                            <div class="record" [ngStyle]="{ width: isAudit ? '26rem' : '100%' }"
                                                *ngIf="isVideoRecordLoaded">
                                                <app-videojs-wavesurfer [recordingDetails]="videoRecordingfile"
                                                    [IsAudio]="false"></app-videojs-wavesurfer>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="accordion-item" id="accordionSix" *ngIf="isTranscript">
                                <h2 class="accordion-header accordion-button section-heading" data-bs-toggle="collapse"
                                    data-bs-target="#collapseSix" aria-expanded="true" aria-controls="collapseSix">
                                    TRANSCRIPT AND INSIGHTS
                                </h2>
                                <hr class="solid-headerDivider" />

                                <div id="collapseSix" class="accordion-collapse collapse accordian-padb"
                                    data-bs-parent="#accordionSix">
                                    <div class="accordion-body">
                                        <div class="record" [ngStyle]="{ width: isAudit ? '20rem' : '100%' }">
                                            <app-call-transcript></app-call-transcript>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="accordion-item" id="accordionTwo">
                                <h2 class="accordion-header accordion-button section-heading" data-bs-toggle="collapse"
                                    data-bs-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
                                    INTERACTION DETAILS
                                </h2>
                                <hr class="solid-headerDivider" />
                                <!-- <h2 class="accordion-header">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                          data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                          INTERACTION DETAILS
                      </button>
                  </h2> -->
                                <div id="collapseTwo" class="accordion-collapse collapse accordian-padb"
                                    data-bs-parent="#accordionTwo">
                                    <div class="accordion-body">
                                        <table class="table">
                                            <tbody>
                                                <tr>
                                                    <td class="info-label">Interaction ID</td>
                                                    <td class="info-value">{{ interactionDetailedData?.InteractionID }}
                                                    </td>
                                                </tr>
                                                    <tr>
                                                    <td class="info-label">Case ID</td>
                                                    <td class="info-value">{{ interactionDetailedData?.CaseIds }}</td>
                                                </tr>
                                                <tr>
                                                    <td class="info-label">Interaction Type</td>
                                                    <td class="info-value">{{ interactionDetailedData?.InteractionType
                                                        }}</td>
                                                </tr>
                                                <tr>
                                                    <td class="info-label">Queue</td>
                                                    <td class="info-value">{{ interactionDetailedData?.Queue }}</td>
                                                </tr>
                                                <tr>
                                                    <td class="info-label">Disposition</td>
                                                    <td class="info-value">{{ interactionDetailedData?.Disposition }}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="info-label">Disposition Type</td>
                                                    <td class="info-value">{{ interactionDetailedData?.DispositionType
                                                        }}</td>
                                                </tr>
                                                <tr>
                                                    <td class="info-label">Request Type</td>
                                                    <td class="info-value">{{ interactionDetailedData?.RequestType }}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="info-label">Agent</td>
                                                    <td class="info-value">{{ interactionDetailedData?.Agent }}</td>
                                                </tr>
                                                <tr>
                                                    <td class="info-label">Group</td>
                                                    <td class="info-value">{{ interactionDetailedData?.Group }}</td>
                                                </tr>
                                                <tr>
                                                    <td class="info-label">Manager</td>
                                                    <td class="info-value">{{ interactionDetailedData?.Manager }}</td>
                                                </tr>
                                                <tr>
                                                    <td class="info-label">User ID</td>
                                                    <td class="info-value">{{ interactionDetailedData?.UserID }}</td>
                                                </tr>
                                                <tr>
                                                    <td class="info-label">CRM User ID</td>
                                                    <td class="info-value">{{ interactionDetailedData?.CrmUserID }}</td>
                                                </tr>
                                                <tr>
                                                    <td class="info-label">User Name</td>
                                                    <td class="info-value">{{ interactionDetailedData?.User }}</td>
                                                </tr>
                                                <tr>
                                                    <td class="info-label">User Phone Number</td>
                                                    <td class="info-value">{{ interactionDetailedData?.PhoneNumber }}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="info-label">Call Started</td>
                                                    <td class="info-value">{{ startedDate }}</td>
                                                </tr>
                                                <tr>
                                                    <td class="info-label">Queued</td>
                                                    <td class="info-value">{{ queuedDate }}</td>
                                                </tr>
                                                <tr>
                                                    <td class="info-label">Answered</td>
                                                    <td class="info-value">{{ answeredDate }}</td>
                                                </tr>
                                                <tr>
                                                    <td class="info-label">Call Ended</td>
                                                    <td class="info-value">{{ endedDate }}</td>
                                                </tr>
                                                <tr>
                                                    <td class="info-label">Call Submitted</td>
                                                    <td class="info-value">{{ submittedDate }}</td>
                                                </tr>
                                                <tr>
                                                    <td class="info-label">Follow-Up Type</td>
                                                    <td class="info-value">{{ interactionDetailedData?.FollowUpType }}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="info-label">Follow-Up Date</td>
                                                    <td class="info-value">{{ followUpDate }}</td>
                                                </tr>
                                                <tr>
                                                    <td class="info-label">Comments</td>
                                                    <td class="info-value"
                                                        [innerHTML]="interactionDetailedData?.Comments"></td>
                                                </tr>
                                                <tr>
                                                    <td class="info-label">Dialer Bypassed</td>
                                                    <td class="info-value">{{ interactionDetailedData?.DialerBypassed }}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="info-label">Bypass Explanation</td>
                                                    <td class="info-value">{{ interactionDetailedData?.BypassExplanation
                                                        }}</td>
                                                </tr>
                                                <tr>
                                                    <td class="info-label">Time in IVR</td>
                                                    <td class="info-value">{{ ivrTime }}</td>
                                                </tr>
                                                <tr>
                                                    <td class="info-label">Time in Queue</td>
                                                    <td class="info-value">{{ queueTime }}</td>
                                                </tr>
                                                <tr>
                                                    <td class="info-label">Time with CSR</td>
                                                    <td class="info-value">{{ csrTime }}</td>
                                                </tr>
                                                <tr>
                                                    <td class="info-label">Handling Time</td>
                                                    <td class="info-value">{{ interactionDetailedData?.HandlingTime }}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="info-label">Total Hold Time</td>
                                                    <td class="info-value">{{ interactionDetailedData?.TotalHoldTime }}
                                                    </td>
                                                </tr>
                                                <ng-container *ngIf="interactionDetailedData?.HoldIntervals?.length > 0">
                                                    <tr>
                                                        <td colspan="2" style="text-align: center;">
                                                          <label class="info-label-heading">Hold Intervals</label>
                                                          <table class="hold-interval-table" cellpadding="5" cellspacing="0" style="margin-left: auto; margin-right: auto;">
                                                              <thead>
                                                                  <tr>
                                                                      <th>Seq No</th>
                                                                      <th>Start Time</th>
                                                                      <th>End Time</th>
                                                                      <th>Duration (sec)</th>
                                                                  </tr>
                                                              </thead>  
                                                              <tbody>
                                                                  <tr *ngFor="let hold of interactionDetailedData?.HoldIntervals">
                                                                      <td>{{ hold.HoldSeqNo }}</td>
                                                                      <td>{{ hold.HoldStartTime | date:'HH:mm:ss a' }}</td>
                                                                      <td>{{ hold.HoldEndTime | date:'HH:mm:ss a' }}</td>
                                                                      <td>{{ hold.HoldDurationSec }}</td>
                                                                  </tr>
                                                              </tbody>
                                                          </table>
                                                        </td>
                                                    </tr>   
                                                </ng-container>    
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div class="accordion-item" id="accordionThree">
                                <h2 class="accordion-header accordion-button section-heading" data-bs-toggle="collapse"
                                    data-bs-target="#collapseThree" aria-expanded="true" aria-controls="collapseThree">
                                    USER INFORMATION
                                </h2>
                                <hr class="solid-headerDivider" />
                                <!-- <h2 class="accordion-header">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                          data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                          USER INFORMATION
                      </button>
                  </h2> -->
                                <div id="collapseThree" class="accordion-collapse collapse accordian-padb"
                                    data-bs-parent="#accordionThree">
                                    <div class="accordion-body">
                                        <table class="table">
                                            <tbody>
                                                <ng-container *ngIf="interactionUserDataKeys?.length; else noData">
                                                    <tr *ngFor="let key of interactionUserDataKeys">
                                                        <td class="info-label">{{ key }}</td>
                                                        <td class="info-value" [innerHTML]="interactionUserData[key]">
                                                        </td>
                                                    </tr>
                                                </ng-container>
                                         
                                            </tbody>
                                        </table>
                                        <ng-template #noData>
                                            <tr>
                                                <td colspan="2" class="text-center">No data available</td>
                                            </tr>
                                        </ng-template>
                                    </div>
                                </div>
                            </div>

                            
                        </div>
                    </div>

                    <div class="col verticalScroll" *ngIf="isAudit">
                        <!-- <div class="col-6 verticalScroll" *ngIf="showAudit == false"> -->
                        <div class="accordion accordion-flush">
                            <div class="accordion-item" id="accordionFour">
                                <h2 class="accordion-header accordion-button section-headin g" data-bs-toggle="collapse"
                                    data-bs-target="#collapseFour" aria-expanded="true" aria-controls="collapseFour">
                                    AUDITS
                                </h2>
                                <hr class="solid-headerDivider" />
                              
                                <div id="collapseFour" class="accordion-collapse collapse show"
                                    data-bs-parent="#accordionFour">
                                    <div class="accordion-body">
                                        <div class="auditForm">
                                            <div class="row">
                                                <div class="col-2 formFont field-label audit-field-label">Forms:</div>
                                                <div class="col-9" style="padding-left: 0.5rem">
                                                    <select name="page" class="audit-dropdown"
                                                        [(ngModel)]="selectedForm" (change)="changeFormField($event)"
                                                        style="width: 93%">
                                                        <ng-container
                                                            *ngFor="let item of filteredAuditArray; let i = index">
                                                            <option [ngValue]="item"
                                                                [selected]="item.Name == this.selectedForm">
                                                                {{ item.Name }}
                                                            </option>
                                                        </ng-container>
                                                    </select>
                                                    <!-- <select [(ngModel)]="selectedForm" (change)="changeFormField($event)">
                                                          <option [selected]='auditForm.Name' value={{auditForm.Name}} *ngFor="let auditForm of filteredAuditArray">{{auditForm.Name}}</option>
                                                      </select></div> -->
                                                    <div class="col-2"></div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-2 field-label audit-field-label">Types:</div>
                                                    <!-- <div class="col-9">
                    <select (change)="getSelectedType($event)">
                      <option
                        *ngFor="let item of selectedTypeArray; let i = index"
                        [ngValue]="item"
                        [selected]="item.Name == this.selectedType?.Name"
                      >
                        {{ item.Name }}
                      </option>
                    </select>
                  </div> -->
                                                    <div class="col-9">
                                                        <select [(ngModel)]="selectedType"
                                                            [ngModelOptions]="{ standalone: true }">
                                                            <option *ngFor="let item of selectedTypeArray"
                                                                [ngValue]="item">
                                                                {{ item.Name }}
                                                            </option>
                                                        </select>
                                                    </div>
                                                    <div class="col-1 openIcon"
                                                        [ngClass]="filteredAuditArray ? '' : 'disabled-content'"
                                                        (click)="createNewAuditSurvey(true)">
                                                        <img alt="" class="icons"
                                                            src="{{ baseHref }}/assets/images/icon-new-folder.svg" /><span>New</span>
                                                    </div>
                                                </div>
                                                <hr class="light-divider" />
                                                <div class="row" *ngIf="showOpenSurvey && !isDeletedSurvey">
                                                    <div class="col-2 field-label audit-field-label">Surveys:</div>
                                                    <div class="col-9">
                                                        <!-- <select>
                      <option
                        *ngFor="let item of selectedSurveyArray; let i = index"
                        [ngValue]="item"
                        [selected]="item.SurveyID == this.selectedSurvey.SurveyID"
                      >
                        {{ item.SurveyID + ':' + selectedForm.Name + '-' + item?.Type?.Name }}({{ item.Status.Name }})
                      </option>
                    </select> -->
                                                        <select [(ngModel)]="selectedSurvey"
                                                            [ngModelOptions]="{ standalone: true }"
                                                            (ngModelChange)="onSurveyChange($event)">
                                                            <option *ngFor="let item of selectedSurveyArray"
                                                                [ngValue]="item">
                                                                {{ item.SurveyID + ':' + selectedForm.Name + '-' +
                                                                item?.Type?.Name }} ({{ item.Status.Name }})
                                                            </option>
                                                        </select>
                                                    </div>
                                                    <div class="col-1 openIcon" (click)="openAuditSurvey()">
                                                        <img alt="" class="icons"
                                                            src="{{ baseHref }}/assets/images/icon-open-folder.svg" />Open
                                                    </div>
 

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="accordion-item" id="accordionFive" *ngIf="isSubmitted">
                                    <div class="row m-0">
                                        <div class="accordion-header accordion-button accordian-section"
                                            data-bs-toggle="collapse" data-bs-target="#collapseFive"
                                            aria-expanded="true" aria-controls="collapseFive">
                                            <div class="col-6 section-heading">{{ newSurveyData.Name }}</div>
                                            <div class="col-4 disp-flex">
                                                <div class="col-7">
                                                    <!-- <span class="submitBtn">
                                                        {{ surveySections.sectionLabelStatus}}
                                                    </span> -->
                                                </div>
                                                <div class="col-5" *ngIf="aiScoreSubmitted">
                                                    
                                                    <div style="font-size:12px; color:#6a6f7b; margin-bottom:2px;">
                                                    AI Score
                                                    </div>

                                                    <div class="nonHeader show-points">
                                                        {{this.auditScore}}
                                                    </div>
                                                </div>
                                            </div>
                                            
<div class="col-2 nonHeader show-points show-perc" style="display:flex; flex-direction:column; align-items:flex-end;">
    <div style="font-size:12px; color:#6a6f7b; margin-bottom:2px;">
        {{ this.aiScoreSubmitted ? 'Final Score' : 'Score'}}
    </div>
    <div>
        {{ surveySections.totalSectionScore}}%
    </div>
</div>

                                            <!-- <div class="col-2 nonHeader show-points show-perc">{{
                                                surveySections.totalSectionScore | number:'1.1-1' }}%</div> -->
                                        </div>
                                    </div>

                                    <hr class="solid-headerDivider" />
                                    <div id="collapseFive" class="accordion-collapse collapse" [class.show]="isSurveyExpanded"
                                        data-bs-parent="#accordionFive">
                                        <div class="accordion accordion-flush">
                                            <div class="accordion-body"
                                                *ngFor="let sectionItems of surveySections; let i = index">
                                                <div class="accordion-item" id="accordion{{ i }}">
                                                    <div class="row m-0 sub-heading">
                                                        <div class="accordion-header accordion-button subService"
                                                            data-bs-toggle="collapse"
                                                            [attr.data-bs-target]="'#collapse' + i" aria-expanded="true"
                                                            [attr.aria-controls]="'collapse' + i">
                                                            <div class="col-6 sub-section-heading">{{ sectionItems.Name}}
                                                                <span *ngIf="(showMandatoryReview() && (sectionItems.Name === 'HIPAA Verification' || sectionItems.Name === 'Disqualifying Event')) || sectionItems.Name === 'Statistical' || sectionItems.Name === 'Above and Beyond' "
                                                                class="mandatory-badge">   Mandatory
                                                               </span>

                                                            </div>

                                                            <div class="col-4 disp-flex">
                                                                <div class="col-6">
                                                                </div>
                                                                <div class="col-6">
                                                                    <div class="show-points sub-points" id="showPoints" style="text-align: center;"
                                                                        *ngIf="aiScoreSubmitted && sectionItems?.showPoints == true">
                                                                        {{sectionItems.aiSurveyScore}}%
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="col-2 show-points"
                                                                *ngIf="sectionItems?.showPoints == true">
                                                                <span style="font-weight:700;">
                                                                    {{ sectionItems.Score % 1 === 0 ? sectionItems.Score : (sectionItems.Score | number:'1.2-2') }}%    
                                                                </span>
                                                                <span>({{ sectionItems.Points }}/{{ sectionItems.Max }})</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <hr class="solid-divider" />

                                                    <div id="collapse{{ i }}" class="accordion-collapse collapse" [class.show]="sectionItems.showMandatorySection"
                                                        [attr.data-bs-parent]="'#accordion' + i">
                                                        <div class="accordion-body">
                                                            <div class="surveyForm">
                                                                    <div class="row form-row" *ngFor="let field of sectionItems.FieldGroup.Fields; let j = index">
                                                                    <div class="col-8 input-data">
                                                                        <div class="disp-grid">
                                                                            <label for="" class="section-items">
                                                                            {{field.Name}}
                                                                            </label>
                                                                            <select name="page{{ field.FieldID }}"
                                                                                class="audit-dropdown"
                                                                                [(ngModel)]="field.selectedFieldOption"
                                                                                (change)="changeFieldOption($event, field.FieldOptions, i, field.selectedFieldOption)">
                                                                                <option
                                                                                    *ngFor="let fieldOptions of field.FieldOptions"
                                                                                    [ngValue]="fieldOptions"
                                                                                    [disabled]="surveySections.sectionLabelStatus === 'Submitted'  && !isSameAgent">
                                                                                    {{ fieldOptions.Name }}
                                                                                </option>
                                                                            </select>
                                                                            <div *ngIf="field.showMandatoryError" class="mandatory-message">~ Human review is mandatory for the field
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                            <div class="col-2 feedback-div">
                                                <div *ngIf="aiScoreSubmitted" style="display: flex;flex-direction: column; align-items: center;">
                                                    <img alt="Star" class="feedback-img" [src]="baseHref + '/assets/images/' + (field?.aiFieldScore >= 0 ? 'icon-star.png' : 'icon-star-red.png')"/>
                                                </div>
                                                <span *ngIf="aiScoreSubmitted" class="feedback-val">{{ field?.aiFieldScore }}</span>
                                            </div>
                                            <div class="col-2" style="display: flex;">
                                                <div class="col-8 feedback-val">
                                                    <img alt="Star" class="feedback-img" [src]="baseHref + '/assets/images/' + ((field?.selectedFieldOption?.ScoreValue ?? 0) >= 0 ? 'icon-star.png' : 'icon-star-red.png')"/>
                                                    <span class="feedback-val" [style.color]="(field?.selectedFieldOption?.ScoreValue ?? 0) < 0 ? 'red' : null">{{ field?.selectedFieldOption?.ScoreValue }}</span>
                                                </div>
                                                <div 
                                                    class="col-4 feedback-val" 
                                                    style="text-align: right;">
                                                        <img 
                                                        alt="Comment" 
                                                        class="feedback-img" 
                                                        [src]="field.isAIComments
                                                        ?  baseHref + '/assets/images/icon-aicomment.png'
                                                        : baseHref + '/assets/images/icon-comment.png'" 
                                                        (click)="showCommentBox(i, j)"/>
                                                </div>
                                                 <!-- <div class="feedback-val" 
                                                        style="text-align: center;">
                                                     <span>{{ field?.commentValue }}</span>
                                                </div> -->
                                            </div>
                                            <div *ngIf="field.showAIComments" style="padding:0">
                                                <div class="sub-section-heading" style="margin-top:1rem; padding-left:0.625rem">AI Comments:</div>
                                                <div class="textarea-outerpart">
                                                    <textarea 
                                                        [(ngModel)]="field.aiComments"
                                                        readonly
                                                        rows="2" cols="45" style="width: 100%; border: 0.063rem solid #2f78c4">
                                                    </textarea>
                                                </div>
                                            </div>          
                                                                    <div *ngIf="field.showComments" style="padding:0">
                                                                            <div class="sub-section-heading" style="margin-top:1rem; padding-left:0.625rem">Human Comments:</div>
                                                                                <div class="textarea-outerpart">
                                                                                    <textarea 
                                                                                        [(ngModel)]="field.Comments"
                                                                                        [disabled]="userEmail != surveyUserEmail && surveySections.sectionLabelStatus === 'Submitted'"
                                                                                        rows="2" cols="45" style="width: 100%; border: 0.063rem solid #2f78c4">
                                                                                    </textarea>
                                                                                </div>
                                                                           
                                                                            <div class="comment-actions"> 
                                                                                 <button 
                                                                                    class="btn submit cancel-btn center-btn" 
                                                                                    style="text-align: center;" 
                                                                                    type="button"
                                                                                    (click)="cancelComment(field,i,j)"
                                                                                    > Cancel 
                                                                                </button>
                                                                                <button 
                                                                                    class="btn submit save-btn center-btn" 
                                                                                    type="button" 
                                                                                    (click)="onSave($event, i, j,field)"
                                                                                    [disabled]="userEmail != surveyUserEmail && surveySections.sectionLabelStatus === 'Submitted'"
                                                                                    > Save 
                                                                                </button>
                                                                            </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                                <div class="mtb-10 button-container">
                                                    <div class="disp-inline" *ngIf="showDeleteBtn == true" (mousedown)="saveSurvey($event, true, 'Delete')">
                                                        <button type="button" class="btn saveBtn">
                                                            <span class="button-text">Delete</span>
                                                        </button>
                                                    </div>
                                                    <div class="disp-inline" *ngIf="showSaveDraftBtn == true" (mousedown)="saveSurvey($event, false, 'Save Changes')">
                                                        <button type="button" class="btn saveBtn">
                                                            <span class="button-text">Save & Draft</span>
                                                        </button>
                                                    </div>
                                                    <div class="disp-inline" *ngIf="showSubmitBtn == true"
                                                        (click)="saveSurveyAI()">
                                                        <button type="button" class="btn saveAIBtn">
                                                            <span
                                                                class="button-text">Submit</span>
                                                        </button>
                                                    </div>
                                                    <div class="disp-inline" *ngIf="showExportBtn == true" (click)="getExportExcel()">
                                                        <button type="button" class="btn exportBtn">
                                                            <!-- <img alt="" class="button-icons" src="{{ baseHref }}/assets/images/icon-download.svg" /> -->
                                                            <span class="button-text"
                                                            >Export Excel</span
                                                            >
                                                        </button>
                                                    </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-4">
                <div class="col-12 top-blocks" *ngIf="hasAIData">
                    <h2 style="margin-left: -1rem;" class="accordion-header accordion-button section-heading"
                        data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true"
                        aria-controls="collapseOne">
                        AI Generated Evaluation
                    </h2>
                    <hr class="solid-headerDivider" />
                    <div class="block-content">
                        <p class="sentiment-label">AI Observations:</p>
                        <div>
                            <p>What Went Well</p>
                            <ul>
                            <li *ngFor="let www of auditResponseData?.AIEvaluationSummary?.whatwentwell" style="margin-bottom: 0.5rem;"> {{ www }}</li>
                            </ul>
                        </div>
                        
                        <p>What Could Be Improved</p>
                        <ul>
                        <li *ngFor="let wc of auditResponseData?.AIEvaluationSummary?.whatcouldbeimproved"> {{ wc }}</li>
                        </ul>
                    </div>
                </div>
                <div class="col-12 top-blocks" *ngIf="hasAIData">
                    <h2 style="margin-left: -1rem;" class="accordion-header accordion-button section-heading"
                        data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true"
                        aria-controls="collapseOne">
                        Sentiment Analysis
                    </h2>
                    <hr class="solid-headerDivider" />
                    <div class="block-content">
                        <!-- Customer Sentiment -->
                        <!-- Agent Sentiment -->
                        <div class="row">
                            <div class="col-12">
                                <label class="sentiment-label">Agent Sentiment:</label>
                                 <div class="row" style="align-items: center; margin-top: 0.5rem;margin-bottom: 0.5rem;">
                                    <div class="col-12">
                                        {{ auditResponseData?.SentimentsAnalysis?.agentsentiment }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Agent Sentiment Reasoning -->
                        <div class="row">
                            <div class="col-12">
                                <label class="sentiment-label">Agent Sentiment Reasoning:</label>
                                <div class="row" style="align-items: center; margin-top: 0.5rem;margin-bottom: 0.5rem;">
                                    <div class="col-12">
                                        {{ auditResponseData?.SentimentsAnalysis?.agentsentimentreasoning }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Caller Sentiment -->
                        <div class="row">
                            <div class="col-12">
                                <label class="sentiment-label">Caller Sentiment:</label>
                                <div class="row" style="align-items: center; margin-top: 0.5rem;margin-bottom: 0.5rem;">
                                    <div class="col-12">
                                        {{ auditResponseData?.SentimentsAnalysis?.callersentiment }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Caller Sentiment Reasoning -->
                        <div class="row">
                            <div class="col-12">
                                <label class="sentiment-label">Caller Sentiment Reasoning:</label>
                                <div class="row" style="align-items: center; margin-top: 0.5rem;margin-bottom: 0.5rem;">
                                    <div class="col-12">
                                        {{ auditResponseData?.SentimentsAnalysis?.callersentimentreasoning }}
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <p-dialog header="Human Review Required" [(visible)]="isMandatoryReviewDialogOpen" [modal]="true" [style]="{width: '40vw'}" [closable]="false">
                <p class="audit-message-confirm">
                 Human review is mandatory for the following questions:
                 </p>
                <div *ngFor="let section of mandatoryReviewSections" style="margin-top: 20px;">
                <!-- <div style="font-weight: 700; margin-bottom: 8px;"> -->
                    <div style="font-size: 14px; font-weight: 600; margin-bottom: 8px;">
                 {{ section.sectionName }}
                </div>
 
        <ul style="margin-bottom: 16px;">
            <li *ngFor="let question of section.questions"
                style=" font-size: 12px; margin-bottom: 6px;">
                {{ question }}
            </li>
        </ul>
         </div>
 
         <div
        class="solid-headerDivider"
        style="margin-top: 2rem;">
         </div>
 
        <ng-template pTemplate="footer">
        <div style="display:flex; justify-content:center; width:100%;">
             <button class="btn submit close-btn center-btn" type="button" (click)="isMandatoryReviewDialogOpen = false">
                Close
              </button>
              </div>
            </ng-template>
 
                </p-dialog>
                <p-dialog header="Confirm Save" [(visible)]="isConfirmOverrideOpen" [modal]="true" [style]="{width: '40vw'}" [closable]="false"> 
                    <p class="audit-message-confirm">You're about to override the current audit score.</p> 
                    <p class="audit-message-confirm">Would you like to Proceed?</p> 
                    <div class="solid-headerDivider" style="margin-top:4rem"></div>
                    <ng-template pTemplate="footer"> 
                        <button class="btn submit cancel-btn center-btn" type="button" (click)="isConfirmOverrideOpen=false">Cancel</button> 
                        <button class="btn submit save-btn center-btn" type="button" (click)="isConfirmOpen($event, false, 'Submit Audit')">Yes</button> 
                    </ng-template> 
                </p-dialog>
                
<p-dialog header="Confirmation"
[(visible)]="isApprovalSuccessOpen"
[modal]="true"
[style]="{width: '40vw'}"
[closable]="false">

<div style="text-align:center; margin-top:15px;">
    <svg width="60" height="60" viewBox="0 0 24 24"
         fill="none" stroke="#2ECC71"
         stroke-linecap="round" stroke-linejoin="round">
  
      <!-- Single circle, thin border -->
      <circle cx="12" cy="12" r="10"
              stroke-width="1.25"
              vector-effect="non-scaling-stroke"></circle>
  
      <!-- Single check, slightly thicker for readability -->
      <path d="M8 12.5l2.5 2.5 5-5"
            stroke-width="1.75"
            vector-effect="non-scaling-stroke"></path>
    </svg>
  </div>
  
<p class="audit-message" style="text-align:center; margin-top:15px;">
Audit review submitted successfully.
</p>

<div class="solid-headerDivider"></div>

<ng-template pTemplate="footer">
<div style="display:flex; justify-content:center; width:100%;">
    <button class="btn submit close-btn center-btn"
          type="button"
          (click)="isApprovalSuccessOpen=false">
      Close
    </button>
</div>
</ng-template>

</p-dialog>

                        <!-- <p-dialog header="Confirmation" [(visible)]="isApprovalSuccessOpen" [modal]="true" [style]="{width: '30vw'}" [closable]="false"> 
                            <p class="audit-message">The audit review has been approved  successfully.</p> 
                            <div class="solid-headerDivider"></div>
                            <ng-template pTemplate="footer"> 
                                <button class="btn submit close-btn center-btn" type="button" (click)="isApprovalSuccessOpen=false"> Close </button>

                               
                             </ng-template>
                             </p-dialog> -->

            </div>




            <!-- <div class="col-4">
                <div class="col-12 top-blocks">
                    <h2 style="margin-left: -1rem;" class="accordion-header accordion-button section-heading"
                        data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true"
                        aria-controls="collapseOne">
                        AI Generated Evaluation
                    </h2>
                    <hr class="solid-headerDivider" />
                    <div class="block-content">
                        <p class="fw-bold">AI Observations:</p>
                        <p> - Agent demonstrated good empathy and product knowledge</p>
                        <p> - Slight delay in providing escalation details</p>
                        <p class="text-gray"> enim ad minim veniam, quis nostrud exercitation ullamco
                            laboris nisi ut aliquip ex ea commodo consequat.</p>
                    </div>
                </div>
                <div class="col-12 top-blocks">
                    <h2 style="margin-left: -1rem;" class="accordion-header accordion-button section-heading"
                        data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true"
                        aria-controls="collapseOne">
                        Sentiment Analysis
                    </h2>
                    <hr class="solid-headerDivider" />
                    <div class="block-content">
                        <div class="row">
                            <div class="col-8">
                                <div>
                                    <label class="sentiment-label">Customer Sentiment:
                                        <span class="sentiment-positive">Positive</span></label>
                                    <div>
                                        <label class="sentiment-sub-label">Keyword Detected:</label>
                                        <span class="keyword-positive">Thank You</span> <span
                                            class="keyword-positive">Helpful</span> <span
                                            class="keyword-positive">Appreciate</span>
                                    </div>
                                    <div>
                                        <label class="sentiment-sub-label mt-3">Tone: </label>
                                        <span class="keyword-positive">Calm</span>
                                        <span class="keyword-positive">Satisfied</span>
                                    </div>
                                </div>

                            </div>
                            <div class="col-4 score-block">
                                <label class="score-positive">92%</label>
                                <label class="score-text">Confidence Score</label>
                            </div>
                        </div>
                        <div class="row" style="margin-bottom: 1.5rem; margin-top: 2.5rem;">
                            <div class="col-8">
                                <div>
                                    <label class="sentiment-label">Agent Sentiment: <span
                                            class="sentiment-neutral">Neutral</span></label>
                                    <div>
                                        <label class="sentiment-sub-label mt-0">Tone: </label>
                                        <span class="keyword-positive">Professional</span> <span
                                            class="keyword-negative">Slightly Rushed</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-4 score-block">
                                <label class="score-neutral">84%</label>
                                <label class="score-text">Confidence Score</label>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="col-12 top-blocks">
                    <h2 style="margin-left: -1rem;" class="accordion-header accordion-button section-heading"
                        data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true"
                        aria-controls="collapseOne">
                        AI Recommendations
                    </h2>
                    <hr class="solid-headerDivider" />
                    <div class="block-content">
                        <p><span class="fw-bold">Training:</span> Lorem ipsum dolor sit amet, consectetur adipiscing
                            elit, sed do eiusmod tempor incididunt ut
                            labore et dolore magna aliqua.</p>

                        <p><span class="fw-bold">Script Optimization:</span> Lorem ipsum dolor sit amet, consectetur
                            adipiscing elit, sed do eiusmod tempor incididunt ut
                            labore et dolore magna aliqua.</p>

                        <p><span class="fw-bold">Customer Experience:</span> Lorem ipsum dolor sit amet, consectetur
                            adipiscing elit, sed do eiusmod tempor incididunt ut
                            labore et dolore magna aliqua.</p>

                        <div class="course-recommendation">
                            <label class="fw-bold">Training Course Recommendations:</label>
                            <ul>
                                <li>Voice of the Customer</li>
                                <li>Transforming Customer Experience</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div> -->
        </div>


    </div>
</div>

<!-- <div class="menu">
  <span class="menu-heading">
    Interaction {{ interactionDetailedData?.InteractionID }} -
    {{ interactionDetailedData?.Agent }}
    <span *ngIf="showSurveyDetails">
      | {{ newName }} {{ selectedType?.Name }} Survey {{ selectedSurvey?.SurveyID }} - Reviewer:
      {{ userDetails?.FirstName + ' ' + userDetails?.LastName }}
    </span>
  </span>
  <span class="close" (click)="closeTaskSelectionMenu()">X</span>
</div> -->